import { configureStore, type Middleware } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { RootReducer } from "./reducers";
import { insightsApi } from "../features/insights/api";
import { assetMonitoringApi } from "../features/asset-monitoring/api";
import { clearAccountQueryCache } from "../hooks/useAccountQuery";
const clearInsightsOnAuthChange: Middleware = (api) => (next) => (action) => {
  const before = api.getState().auth;
  const result = next(action);
  const after = api.getState().auth;
  if (
    before.user?.id !== after.user?.id ||
    (before.isAuthenticated && !after.isAuthenticated)
  ) {
    clearAccountQueryCache();
    api.dispatch(insightsApi.util.resetApiState());
    api.dispatch(assetMonitoringApi.util.resetApiState());
  }
  return result;
};
// Keep existing reducers/thunk behavior; add only the Insights resource cache.
export const store = configureStore({
  reducer: RootReducer,
  middleware: (defaults) =>
    defaults({ serializableCheck: false, immutableCheck: false }).concat(
      insightsApi.middleware,
      assetMonitoringApi.middleware,
      clearInsightsOnAuthChange,
    ),
  devTools: import.meta.env.DEV,
});
setupListeners(store.dispatch);
